import { useEffect, useState } from 'react'
import api from '../services/api'

// Observações Gerais (TMOTOBS, cadmot.motobs — texto livre de até 8000 caracteres)

const LIMITE = 8000

export default function FuncionarioObservacoesModal({ motcod, motnome, onClose }: { motcod: string; motnome: string; onClose: () => void }) {
  const [obs, setObs] = useState<string | null>(null)
  const [erro, setErro] = useState('')
  const [aviso, setAviso] = useState('')
  const [salvando, setSalvando] = useState(false)

  async function carregar() {
    const r = await api.get(`/funcionarios/${encodeURIComponent(motcod)}/observacoes`)
    setObs(r.data.obs)
  }

  useEffect(() => {
    carregar().catch(() => setErro('Não foi possível carregar as observações.'))
  }, [motcod])

  async function salvar() {
    setErro(''); setAviso('')
    setSalvando(true)
    try {
      const r = await api.put(`/funcionarios/${encodeURIComponent(motcod)}/observacoes`, { obs })
      await carregar()
      setAviso(r.data?.semAlteracao ? 'Nenhuma alteração para salvar.' : 'Observações salvas.')
    } catch (e: any) {
      setErro(e?.response?.data?.error || 'Erro ao salvar as observações.')
    } finally {
      setSalvando(false)
    }
  }

  return (
    <div className="modal-overlay" style={{ zIndex: 1300 }} onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box" style={{ maxWidth: 760, maxHeight: '92vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header" style={{ gap: '1rem' }}>
          <div style={{ minWidth: 0 }}><h2>{`Observações Gerais — ${motcod} · ${motnome}`}</h2></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexShrink: 0, marginLeft: 'auto' }}>
            <span style={{ fontSize: '0.78rem', fontWeight: 700, color: 'rgba(219,234,254,0.8)' }}>TMOTOBS</span>
            <button className="modal-fechar" onClick={onClose}>✕</button>
          </div>
        </div>

        <div className="modal-corpo">
          {obs === null ? (
            <p style={{ color: erro ? '#dc2626' : '#6b7280' }}>{erro || 'Carregando...'}</p>
          ) : (
            <div className="field-cad">
              <label>Observações</label>
              <textarea value={obs} maxLength={LIMITE} rows={14} spellCheck={false}
                style={{ width: '100%', boxSizing: 'border-box', fontFamily: 'Consolas, monospace', fontSize: '0.85rem', lineHeight: 1.45, resize: 'vertical' }}
                onChange={e => setObs(e.target.value)} />
              <div style={{ fontSize: '0.72rem', color: '#6b7280', textAlign: 'right', marginTop: 2 }}>{obs.length} / {LIMITE}</div>
            </div>
          )}

          {obs !== null && erro && <p style={{ color: '#dc2626', fontSize: '0.82rem', margin: '1rem 0 0' }}>{erro}</p>}
          {aviso && <p style={{ color: '#16a34a', fontSize: '0.82rem', margin: '1rem 0 0' }}>{aviso}</p>}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Fechar</button>
          <button className="btn btn-orange" onClick={salvar} disabled={salvando || obs === null}>{salvando ? 'Salvando...' : 'Salvar'}</button>
        </div>
      </div>
    </div>
  )
}
